import { i18n_t as $t } from '@/utils/i18n';

export const RAGE_CLICK = 'rageClick';

export const ERROR_CLICK = 'errorClicks';

export const DEAD_CLICK = 'deadClicks';

export const TRENDING_DOWN = 'trendingDown';

export const TRENDING_UP = 'trendingUp';

export const FIRST_TIME_USE = 'firstTimeUse';

export const RELEVANCE = 'relevance';

export const INSIGHT_CATEGORIES = {
    TRENDING_UP,
    TRENDING_DOWN,
    RAGE_CLICK,
    ERROR_CLICK,
    DEAD_CLICK,
    FIRST_TIME_USE,
    RELEVANCE,
};

export const FRUSTRATION_INSIGHT_TYPES = [RAGE_CLICK, ERROR_CLICK, DEAD_CLICK];

export const DATE_DEPENDENT_INSIGHT_TYPES = [RAGE_CLICK, ERROR_CLICK, DEAD_CLICK, FIRST_TIME_USE];

export const INSIGHT_CARD_ICONS = {
    [TRENDING_UP]: 'trending-up',
    [TRENDING_DOWN]: 'trending-down',
    [RAGE_CLICK]: 'angry',
    [ERROR_CLICK]: 'alert-triangle',
    [DEAD_CLICK]: 'skull',
    [FIRST_TIME_USE]: 'user-plus',
};

export const INSIGHT_CARD_TYPES = {
    PLAYER: 'player',
    LIBRARY: 'library',
};

export const MIN_REPLAYS_ALLOWED = 3;

export const PAGE = 'Page';

export const FEATURE = 'Feature';

export const GUIDE = 'Guide';

export const TRACK_TYPE = 'TrackType';

export const UNSUPPORTED_INSIGHT_FILTERS = {
    [TRENDING_UP]: ['guide', 'date'],
    [TRENDING_DOWN]: ['guide', 'date'],
    [RAGE_CLICK]: ['guide', 'trackType'],
    [ERROR_CLICK]: ['guide', 'trackType'],
    [DEAD_CLICK]: ['guide', 'trackType'],
    [FIRST_TIME_USE]: ['account', 'apps', 'segment', 'visitor'],
};

export const VALUE_ACTIONS = {
    COPY_LINK: 'copy link - full replay',
    COPY_LINK_CLIP: 'copy link - clip',
    SAVE_CLIP: 'save clip',
    ADD_TO_PLAYLIST: 'add to playlist',
    CREATE_ISSUE: 'create issue',
    CREATE_FUNNEL: 'create funnel',
    CREATE_DX: 'create dx report',
};

export const SUGGESTED_REPLAY_FEEDBACK_ACTIONS = {
    DISLIKE: 'dislike',
    LIKE: 'like',
};

export const SUGGESTED_REPLAY_FEEDBACK_TRACK_EVENT = 'suggestedReplayFeedback';

export const REPLAY_SUMMARY_FEEDBACK_TRACK_EVENT = 'replaySummaryFeedback';

export const SUGGESTED_REPLAY_DISLIKE_OPTION_KEYS = {
    NOT_ACCURATE_OR_TRUSTWORTHY: 'notAccurateOrTrustworthy',
    DETAILS_FELT_INSIGNIFICANT: 'detailsFeltInsignificant',
    OBVIOUS_OR_ALREADY_KNOWN: 'obviousOrAlreadyKnown',
    NOT_RELEVANT_TO_PRODUCT_AREA: 'notRelevantToProductArea',
    OTHER: 'other',
};

export const SUGGESTED_REPLAY_LIKE_OPTION_KEYS = {
    NEW_OR_UNEXPECTED: 'newOrUnexpected',
    SUSPECTED_OR_DISCUSSED: 'suspectedOrDiscussed',
    IMPORTANT_CHANGE: 'importantChange',
    RELEVANT_TO_CURRENT_WORK: 'relevantToCurrentWork',
    OTHER: 'other',
};

export const INSIGHT_TYPE_TO_IGNORED_FRUSTRATION_TYPE = {
    [RAGE_CLICK]: 'rageClick',
    [ERROR_CLICK]: 'errorClick',
    [DEAD_CLICK]: 'deadClick',
};

export const MIN_FRUSTRATED_CLICK_COUNT = {
    [RAGE_CLICK]: 1,
    [ERROR_CLICK]: 3,
    [DEAD_CLICK]: 3,
};

export const ALL_ALLOWED_INSIGHT_TYPES = [
    FIRST_TIME_USE,
    TRENDING_UP,
    TRENDING_DOWN,
    DEAD_CLICK,
    ERROR_CLICK,
    RAGE_CLICK,
];

export const DISABLED = 'disabled';

export function getInsightTypeLabelMap () {
    return {
        [FIRST_TIME_USE]: $t('suggestedReplayInsightTypes.First-time use'),
        [TRENDING_UP]: $t('suggestedReplayInsightTypes.Usage trending up'),
        [TRENDING_DOWN]: $t('suggestedReplayInsightTypes.Usage trending down'),
        [DEAD_CLICK]: $t('suggestedReplayInsightTypes.Most dead clicks'),
        [ERROR_CLICK]: $t('suggestedReplayInsightTypes.Most error clicks'),
        [RAGE_CLICK]: $t('suggestedReplayInsightTypes.Most rage clicks'),
    };
}

export function getInsightTypeOptions () {
    const labels = getInsightTypeLabelMap();

    return [
        { id: FIRST_TIME_USE, displayLabel: labels[FIRST_TIME_USE] },
        { id: TRENDING_UP, displayLabel: labels[TRENDING_UP] },
        { id: TRENDING_DOWN, displayLabel: labels[TRENDING_DOWN] },
        {
            id: DEAD_CLICK,
            displayLabel: labels[DEAD_CLICK],
            tooltip: $t('suggestedReplayInsightTypes.tooltip.Most_dead_clicks__Surfaces_replays_with_clicks_that_didn__t_result_in_any_visible_changes_in_your_application__in_the_selected_date_range_'),
            ariaLabel: $t('suggestedReplayInsightTypes.More information about most dead clicks'),
        },
        {
            id: ERROR_CLICK,
            displayLabel: labels[ERROR_CLICK],
            tooltip: $t('suggestedReplayInsightTypes.tooltip.Most error clicks: Surfaces replays with Feature clicks that generated a client-side Javascript error, in the selected date range.'),
            ariaLabel: $t('suggestedReplayInsightTypes.More information about most error clicks'),
        },
        {
            id: RAGE_CLICK,
            displayLabel: labels[RAGE_CLICK],
            tooltip: $t('suggestedReplayInsightTypes.tooltip.Most rage clicks: Surfaces replays with repetitive clicks in a focused area of your application, in the selected date range.'),
            ariaLabel: $t('suggestedReplayInsightTypes.More information about most rage clicks'),
        },
    ];
}
